export default __webpack_public_path__ + "static/media/back-oval.67ff3a6c.svg";